import type { Flags } from "@/providers/LaunchDarklyProvider";
import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * The `canvas-toolbar-redraw` flag: on is the redrawn primary toolbar, off
 * or absent is main's. The page reads it once and switches at the mounts;
 * nothing below them knows the flag exists.
 */
export function useCanvasToolbarRedraw(): boolean {
  const flags = useFlags<Flags>();
  return flags.canvasToolbarRedraw ?? false;
}
